export const DEFAULT_LOCALE = 'ro';
export const SITE_UNDER_CONSTRUCTION = false;
